// extracted by mini-css-extract-plugin
export default {"header":"JLhSD","client-choice-type":"psMdj"};